module.exports = __webpack_public_path__ + "img/foldable_grocery_thumb.2562284b.jpg";